import React from 'react';
import Navbar from './Navbar.js';
import Footer from './footer.js';
import './Lawyer.css';
import lawyerImage from './lawyer.png';

const Lawyer = () => {
  return (
    <div className="legal-patent-page">
      <Navbar />
      <main className="legal-patent-hero">
          <h1>Cnyda Dynamics Patents Division</h1>
        <section className="legal-patent-body">
          <h2 className="legal-patent-sub-heading">AI Lawyer Patent:</h2>
          
          <div className="legal-patent-description">
            <p>
              The fundamental right of any citizen to protect their property and preserve their self-respect through legal recourse must be absolute, remaining entirely independent of their socioeconomic status. True justice cannot function as a luxury good; it must be inherently accessible and affordable, ensuring that the legal system serves as a shield for the many rather than a gatekept privilege for the few.
              At the forefront of this mission, our company is actively developing innovative Artificial Intelligence systems engineered to mirror complex human cognitive processes. These systems offer exceptional reliability and analytical depth at a mere fraction of the cost associated with current industry standards. By bridging this affordability gap, 
              we are democratizing access to high-level legal and intellectual tools, empowering common citizens to engage with their rights and responsibilities with newfound efficacy. To realize this vision, we aim to forge strategic collaborations with governments and corporations, facilitating technology-driven policy shifts that formalize these advancements and embed them into the societal infrastructure.
            </p>

            <img 
              src="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?q=80&w=2070&auto=format&fit=crop" 
              alt="Digital Law and Justice" 
              className="legal-patent-media"
            />

            <p>
              Yet, this endeavor is not without deep contention. Critics often raise concerns regarding the automation of legal and protective services, 
              questioning whether an AI—no matter how advanced—can truly grasp the nuanced, humanistic moral weight required to weigh property rights and personal dignity. There is a palpable anxiety that placing such powerful analytical tools in the hands of the public could lead to an overload of the judicial system, or conversely, create new forms of 'algorithmic inequality' where legal outcomes are determined by the quality of one's AI rather than the merits of the case. Furthermore, skeptics caution against the risks of public-private partnerships in governance, fearing that relying on corporate-developed AI to influence policy might lead to hidden biases or the erosion of democratic oversight. The central challenge remains: can we effectively leverage the efficiency of superior technology to democratize justice without compromising the essential human safeguards that define a fair and equitable legal system?
              As you look to integrate these narratives into your work at Cnyda Dynamics, how would you like to balance the technological promotion of these systems with the complex ethical debates that surround them?
            </p>
           
          </div>    
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Lawyer;